export interface BreadcrumbItem {
  label: string;
  routerLink?: string;
  type?: BreadcrumbType;
  jobId?: number;
  isLoading?: boolean;
}

export enum BreadcrumbType {
  // Können wir ggf. erweitern, falls wir weitere Unterscheidungen brauchen
  JOB = 'job', 
}